import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import { IVaultSubscription, IVaultSubscriptionUpdate } from './interfaces';

const basePath = '/subscriptions';

/* eslint-disable implicit-arrow-linebreak */

export const getVaultSubscriptions = (): AxiosPromise<IApiResponse<Array<IVaultSubscription>>> =>
  vaultApi.getInstance().get(`${basePath}`);

export const createVaultSubscription = (subscription: IVaultSubscription): AxiosPromise<IApiResponse<IVaultSubscription>> =>
  vaultApi.getInstance().post(`${basePath}`, subscription);

export const updateVaultSubscription = (subscription: IVaultSubscription): AxiosPromise<any> =>
  vaultApi.getInstance().put(`${basePath}/${subscription._id}`, <IVaultSubscriptionUpdate>subscription);
